<section *ngIf="infoReportNotes">
  <div class="card">
    <div class="card-body">
      <p class="text-pre-wrap">{{infoReportNotes}}</p>
    </div>
  </div>
  <button type="button" (click)="showInfoReportNotes.emit(false)" class="btn btn-active my-3">Close</button>
</section>
